import React, { useContext } from 'react'

import { LaunchSketchAlert } from 'containers/modals/LaunchSketchAlert'
import { ModalContext } from 'containers/ModalManager'
import { DocumentDownloadFragment, ShareInfoFragment } from '@sketch/gql-types'
import { DownloadProps } from 'modules/shares/utils'
import { useBreakpoint, Dropdown } from '@sketch/components'

export interface ShareForDownloadOptions
  extends Pick<
    ShareInfoFragment,
    'userCanUpdateSettings' | 'identifier' | 'userCanEdit' | 'type'
  > {}

interface DownloadOptionsProps {
  share: ShareForDownloadOptions
  download: DownloadProps
  document: DocumentDownloadFragment
  isViewingLatestVersion?: boolean
}

const DownloadOptions: React.FC<DownloadOptionsProps> = ({
  share,
  document,
  download,
  isViewingLatestVersion,
}) => {
  const { showModal } = useContext(ModalContext)
  const isDesktop = useBreakpoint('sm')

  const showLibraryItem = share.type === 'LIBRARY'
  const showTemplateItem = share.type === 'TEMPLATE'
  const showOpenInSketchItem = document?.userCanOpenInApp || false

  const elements: React.ReactNode[] = []

  if (showLibraryItem && isDesktop) {
    elements.push(
      <Dropdown.Item
        key={2}
        onClick={() =>
          showModal(LaunchSketchAlert, {
            shareId: share.identifier,
            action: 'addLibrary',
          })
        }
      >
        Add Library
      </Dropdown.Item>
    )
  }

  if (
    showOpenInSketchItem &&
    isViewingLatestVersion &&
    showTemplateItem &&
    isDesktop
  )
    elements.push(
      <Dropdown.Item
        key={3}
        onClick={() =>
          showModal(LaunchSketchAlert, {
            shareId: share.identifier,
            action: 'newFromTemplate',
          })
        }
      >
        New from Template
      </Dropdown.Item>
    )

  if (showOpenInSketchItem && isViewingLatestVersion && isDesktop)
    elements.push(
      <Dropdown.Item
        key={0}
        onClick={() =>
          showModal(LaunchSketchAlert, {
            shareId: share.identifier,
            action: 'openInSketch',
          })
        }
      >
        Edit
      </Dropdown.Item>
    )

  if (download.isAvailable) {
    elements.push(
      <Dropdown.Download key={1} href={download.url}>
        Download
      </Dropdown.Download>
    )
  }

  if (elements.length <= 0) return null
  return <>{elements}</>
}

export default DownloadOptions
